// extracted by mini-css-extract-plugin
export default {"root":"app_root__dl6yq","open":"app_open__1AEF9","customTransition":"app_customTransition__LAZWd","close":"app_close__A1M0U"};